import { MessageSection } from './AiChatBot'
import { Know } from './Know'
import { User } from './User'

export interface ChatMessage {
    uuid: string
    user: User
    message: string
    createdOn: string
    hasOriginalMessage: false
    attachmentUrl: string | null
    know: Know | null
    userIdentification: string
    manualChatMessageUuid: string | null
    allowLinks: boolean
    threadMessageCount: number
    chatUuid: string
    voiceMessagePath: string | null
}

export enum ChatType {
    Group = 'GROUP',
    OneOnOne = '1:1',
}

export interface UserChat {
    uuid: string
    chatPartner: User | null
    hasBlocked: boolean
    lastMessage: ChatMessage | null
    unreadCount: number
    chatType: ChatType
    memberCount: number
    name: string
    chatOwnerUserUuid: string | null
    chatPictureUrl: string | null
    description: string | null
}

export interface ChatMessageCreateRequest {
    knowUuid: string | null
    message: string
    attachmentPath: string | null
    parentUuid?: string | null
}

export interface DisplayChatMessage {
    uuid: string
    message: string
    createdOn: Date | string
    userIdentification: string
    attachmentUrl?: string | null
    know?: Know | null
    allowLinks: boolean
    threadMessageCount: number
    chatUuid: string
    voiceMessagePath: string | null
    messageSections?: MessageSection[]
    knows?: Know[]
    isBotMessage?: boolean
}

export interface ChatTrackingSnippet {
    uuid: string
    partnerUserUuid: string | null
}

export interface ChatMessageTrackingSnippet {
    uuid: string
    createdOn: string
    senderUserUuid: string
    receiverUserUuid: string | null
    contentType: 'TEXT' | 'KNOW' | 'IMAGE'
    source: 'MANUAL' | 'USER_WRITTEN'
}
